import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import LoginPage from 'src/components/views/Login/LoginPage';
import { userLogin } from 'src/redux/actions/authCreator';
import { ILoginParam } from 'src/entity/LoginParam';
import { getUserInfo } from 'src/redux/actions/userCreator';
import { updateMenu } from 'src/redux/actions/sideLayoutCreator';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    authLogin: (authRequest: ILoginParam) => dispatch(userLogin(authRequest)),
    getUserInfo: () => dispatch(getUserInfo()),
    updateMenu: (pathName: string) => dispatch(updateMenu(pathName)),
    dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/containers/Login.ts